import React from 'react'
import CompanyName from './Component/CompanyName';
import HomeImage from './Images/GotenbergSolutionTemp.jpeg'
import OptimizedImage from './Component/OptimizedImage';
import { PiPhoneCall } from "react-icons/pi";
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material';
import Team from './Component/Team';



const theme = createTheme({
    palette: {
        primary: {
            main: "#F61832", // custom primary color
        },
        secondary: {
            main: "#C13E39", // custom secondary color
        },
    },
});

const About = () => {

const currentYear = new Date().getFullYear();
const Since = currentYear - 1985; 

  return (
    <article className='max-w-[1200px] mx-auto px-8 pt-8'>
<title>About Gotenberg Solution</title>
<h1 className='text-2xl font-bold pb-4'>About <CompanyName/></h1>
<div className='lg:flex lg:gap-10 '>
  <div className='lg:w-6/12'>

    <p className='pb-4'><CompanyName/> is a premier printing and design company based in Egypt, renowned for delivering exceptional quality and innovative solutions. With over {Since} years of expertise in the industry, we have evolved from humble beginnings with basic printing capabilities to becoming a trusted partner for major corporations. Our founder, Mahmoud Abu Al-Nawas, dedicated years to research, experimentation, and skill development, establishing a strong foundation in commercial printing, packaging, and branded merchandise. Through relentless innovation, we have mastered advanced techniques to ensure high-quality, durable prints and bring the most creative designs to life across a wide range of products.</p>
    <p >At <CompanyName/>, professionalism and excellence are at the core of our operations. We take pride in our team of highly trained designers and printing specialists, who are committed to delivering customized, cutting-edge solutions tailored to each client’s needs. Whether it’s branding, promotional materials, or packaging design, we combine state-of-the-art technology with artistic vision to produce outstanding results. As a leader in Egypt’s printing and design industry, we remain dedicated to pushing boundaries, fostering creativity, and maintaining the highest standards of customer satisfaction and product reliability.</p>
  
          <div className='my-8 lg:w-6/12 mx-auto'>
          <ThemeProvider theme={theme}>
            <Button color="primary" variant="contained" size="large" fullWidth endIcon={<PiPhoneCall/>} href='tel:+201114000025'>
              Call Now
            </Button>
          </ThemeProvider>
        </div>

  </div>
  <div className='lg:w-6/12'>
  <OptimizedImage 
  src={HomeImage}
  // srcSet="/Images/GotenbergSolutionTemp.jpeg 400w, /Images/GotenbergSolutionTemp.jpeg 800w, /Images/GotenbergSolutionTemp.jpeg 1200w"
  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
  className='lg:rounded-tl-full shadow-2xl'
  alt="Product image"
  width={800}
  height={600}
  />
  </div>
</div>

<section><Team/></section>
    </article>
  )
}

export default About
